import React from "react"

export function Loading() {
    return (
        <div className="d-flex justify-content-center m-5">
            <div className="spinner-border text-primary align-self-center" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
}